import src from "IMAGE";
export default { src, width: 368, height: 368, blurWidth: 0, blurHeight: 0};
